export default "__VITE_ASSET__ef89749e__"